'use strict';

var typography = require('../../../../../../../../../../_virtual/typography4.cjs');
var intentionColors = require('../../base/ds5/intentionColors.cjs');

var hasRequiredTypography;

function requireTypography () {
	if (hasRequiredTypography) return typography.__exports;
	hasRequiredTypography = 1;

	var intentionColors$1 = intentionColors.__require();

	var NEUTRAL_INTENTION = /*#__PURE__*/ function(NEUTRAL_INTENTION) {
	    NEUTRAL_INTENTION[NEUTRAL_INTENTION["neutral"] = intentionColors$1.INTENTION_COLORS.neutral] = "neutral";
	    return NEUTRAL_INTENTION;
	}({});
	var INVERSE_INTENTION = /*#__PURE__*/ function(INVERSE_INTENTION) {
	    INVERSE_INTENTION[INVERSE_INTENTION["inverse"] = intentionColors$1.INTENTION_COLORS.inverse] = "inverse";
	    return INVERSE_INTENTION;
	}({});
	var TYPOGRAPHY_INTENTIONS = /*#__PURE__*/ function(TYPOGRAPHY_INTENTIONS) {
	    TYPOGRAPHY_INTENTIONS[TYPOGRAPHY_INTENTIONS["neutral"] = intentionColors$1.INTENTION_COLORS.neutral] = "neutral";
	    TYPOGRAPHY_INTENTIONS[TYPOGRAPHY_INTENTIONS["inverse"] = intentionColors$1.INTENTION_COLORS.inverse] = "inverse";
	    return TYPOGRAPHY_INTENTIONS;
	}({});

	typography.__exports.INVERSE_INTENTION = INVERSE_INTENTION;
	typography.__exports.NEUTRAL_INTENTION = NEUTRAL_INTENTION;
	typography.__exports.TYPOGRAPHY_INTENTIONS = TYPOGRAPHY_INTENTIONS;
	
	return typography.__exports;
}

exports.__require = requireTypography;
//# sourceMappingURL=typography.cjs.map
